export const DatetimeFormat = "YYYY-MM-DDTHH:mm:ss";
export const DateFormat = "DD/MM/YYYY";
